import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Loader2, ChevronRight, Wrench } from 'lucide-react';
import api from '../../lib/api';

export default function OperacionesEdificios() {
  const navigate = useNavigate();
  const [edificios, setEdificios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/edificios').then(r => setEdificios(r.data || [])).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-screen flex justify-center items-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-11 h-11 rounded-xl bg-amber-100 flex items-center justify-center">
          <Wrench className="w-5 h-5 text-amber-700" strokeWidth={1.7} />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Operaciones</h1>
          <p className="text-slate-500 text-sm">Salas · Usuarios del edificio · Incidencias</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {edificios.map(e => (
          <button
            key={e.edificio_id}
            data-testid={`edif-card-${e.edificio_id}`}
            onClick={() => navigate(`/operaciones/edificio/${e.edificio_id}`)}
            className="text-left p-4 bg-white border border-slate-200 rounded-xl hover:border-amber-400 hover:shadow-sm transition-all flex items-center gap-3"
          >
            <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
              <Building2 className="w-5 h-5 text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900 truncate">{e.nombre}</div>
              <div className="text-xs text-slate-500 truncate">{e.ubicacion || ''}</div>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400" />
          </button>
        ))}
      </div>
    </div>
  );
}
